import * as types from '../mutation-types'
import api from '@/api/solution'

// initial state
const state = {
    solutions: [],
    solution: {},
    loaded: false,
    solutionsLoaded: false,
}

const getters = {
    solutions: state => state.solutions,
    solutionsLoaded: state => state.solutionsLoaded,
    solution: state => state.solution,
    dynamicSolution: (state) => {
        if(state.solution._embedded && state.solution._embedded.Content) {
            return state.solution && state.solution._embedded && Number(state.solution._embedded.Content.contentDynamic) === 1
        }
        return false
    },
    solutionContent: (state, getters) => {
        if(!getters.dynamicSolution) {
            return [state.solution.contentSolution]
        }
        //title?
        return getters.dynamicContent(['HTML']).map(item => item.value)
    },
    solutionAssets: (state, getters) => {
        if(!getters.dynamicSolution) {
            return []
        }
        return getters.dynamicContent(['VIDEO', 'LINK', 'FILE'])
    },
    solutionContacts: (state, getters) => {
        if (!getters.dynamicSolution){
            return []
        }
        let dynamicContentTeamMember = getters.dynamicContentTeamMember ? getters.dynamicContentTeamMember : []
        let dynamicContacts = state.solution._embeded.TeamMemberContent  ? state.solution._embeded.TeamMemberContent  : []
        let contacts = [...dynamicContentTeamMember, ...dynamicContacts ]
        let unique = [];
        contacts.forEach(item => {
            if(!unique.find(elem => elem.idTeamMember === item.idTeamMember)) {
                unique.push(item);
            }
        });
        return unique
    },
    dynamicContent: (state) => (types) => {
        return state.solution._embeded.ContentDynamic.filter(item => {
            return types.includes(item.type)
        }).map(item => {
            return {
                id: item.idContentDynamic,
                title: item.customTitle ? item.customTitle : item._embedded.title.value,
                description: item.contentDescription,
                value: item.type === 'FILE' ? item._embedded.file.idFile : item.value,
                size: item.type === 'FILE' ? item._embedded.file.size : null,
                fileType: item.type === 'FILE' ? item._embedded.file.type : null,
                type: item.type,
            }
        })
    },
    dynamicContentTeamMember: (state) => {
        return state.solution._embeded.ContentDynamic.filter(item => {
            return ['TEAMMEMBER'].includes(item.type)
        }).map(item => {
            return item._embedded.teamMember
        })
    },
    solutionLoaded: state => state.loaded,
}

const actions = {
    getSolutions({ commit }, params) {
        commit(types.SET_SOLUTIONS_LOADED, false );
        api.getSolutions(params, (response) => {
            commit(types.SET_SOLUTIONS, response._embedded.Solution );
            commit(types.SET_SOLUTIONS_LOADED, true );
        })
    },
    getSolution({ commit }, id) {
        commit(types.SET_SOLUTION_LOADED, false );
        api.getSolution(id, (response) => {
            commit(types.SET_SOLUTION, response );
            commit(types.SET_SOLUTION_LOADED, true );
        })
    },
    cleanSolution({commit}) {
        commit(types.SET_SOLUTION_LOADED, false );
        commit(types.SET_SOLUTION, {} );
    }
}

const mutations = {
    [types.SET_SOLUTION] (state, solution ) {
        state.solution = solution
    },
    [types.SET_SOLUTION_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_SOLUTIONS] (state, solution ) {
        state.solutions = solution
    },
    [types.SET_SOLUTIONS_LOADED] (state, status ) {
        state.solutionsLoaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


